import { render } from "./CarWearCalculator.vue?vue&type=template&id=ee522e66&scoped=true"
import script from "./CarWearCalculator.vue?vue&type=script&lang=js"
export * from "./CarWearCalculator.vue?vue&type=script&lang=js"

import "./CarWearCalculator.vue?vue&type=style&index=0&id=ee522e66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee522e66"]])

export default __exports__